export enum SegmentationStatus {
    UNKNOWN = 0,
    NOT_STARTED = 1,
    IN_PROCESS = 2,
    COMPLETED = 3,
    ERROR = 4,
    FAILED = 5,
}
